import { render, staticRenderFns } from "./AboutFAQ.vue?vue&type=template&id=7fc39ddb&scoped=true&"
import script from "./AboutFAQ.vue?vue&type=script&lang=js&"
export * from "./AboutFAQ.vue?vue&type=script&lang=js&"
import style0 from "./AboutFAQ.vue?vue&type=style&index=0&id=7fc39ddb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc39ddb",
  null
  
)

export default component.exports